import { makeStyles, tokens } from "@microsoft/shifts-ui-core";

export const useEmptyConstraintsListStyles = makeStyles({
    container: {
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: `${tokens.spacingVerticalXXL} ${tokens.spacingHorizontalL}`,
        gap: tokens.spacingVerticalM,
        height: "100%"
    },
    iconContainer: {
        marginBottom: tokens.spacingVerticalL
    },
    icon: {
        width: "8rem",
        height: "8rem",
        display: "block"
    },
    description: {
        maxWidth: "17.5rem",
        marginBottom: tokens.spacingVerticalL,
        textAlign: "center",
        color: tokens.colorNeutralForeground1
    },
    enableButton: {
        minWidth: "10rem"
    }
});